/* HOME PASSION · video slider
   TEK OYNATICI: ayni anda yalnizca ekranin ortasina en yakin kart oynar.
   NOT: rAF kisilabildigi icin zamanlayici kullanilir. */
(function(){
  'use strict';
  var RM=window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function attach(v){
    if(v.dataset.src2==='1') return;
    v.dataset.src2='1';
    v.querySelectorAll('source[data-src]').forEach(function(s){ s.src=s.dataset.src; });
    try{ v.load(); }catch(e){}
  }
  function detach(v){
    if(v.dataset.src2!=='1') return;
    try{ v.pause(); }catch(e){}
    v.querySelectorAll('source').forEach(function(s){ s.removeAttribute('src'); });
    v.removeAttribute('src');
    try{ v.load(); }catch(e){}
    v.dataset.src2='';
  }

  function init(root){
    (root||document).querySelectorAll('.hp-vid-vp').forEach(function(vp){
      if(vp.dataset.vidInit) return; vp.dataset.vidInit='1';

      var cards=[].slice.call(vp.querySelectorAll('.hp-vid'));
      var withVideo=cards.filter(function(c){ return c.querySelector('video'); });
      if(!withVideo.length){ cards.forEach(function(c){c.classList.add('ready')}); return; }
      if(RM){ cards.forEach(function(c){ c.classList.add('ready'); }); return; }

      var active=null, timer=null;

      function pick(){
        timer=null;
        var vr=vp.getBoundingClientRect();
        var onScreen = vr.bottom > 0 && vr.top < (window.innerHeight||800);
        if(!onScreen){
          if(active){ detach(active.querySelector('video')); active.classList.remove('ready','sound'); active=null; }
          return;
        }
        var cx=vr.left+vr.width/2, best=null, bestD=Infinity;
        withVideo.forEach(function(c){
          var r=c.getBoundingClientRect();
          if(r.right<vr.left-10||r.left>vr.right+10) return;
          var d=Math.abs(r.left+r.width/2-cx);
          if(d<bestD){ bestD=d; best=c; }
        });
        if(best===active) return;
        if(active){
          var ov=active.querySelector('video');
          if(ov){ ov.muted=true; }
          active.classList.remove('sound');
          detach(ov);
          active.classList.remove('ready');
        }
        active=best;
        if(active){
          var v=active.querySelector('video');
          attach(v);
          active.classList.add('ready');
          var pr=v.play(); if(pr&&pr.catch) pr.catch(function(){});
        }
      }
      function schedule(){ if(timer) return; timer=setTimeout(pick,120); }

      vp.addEventListener('scroll',schedule,{passive:true});
      addEventListener('scroll',schedule,{passive:true});
      addEventListener('resize',schedule,{passive:true});
      [400,1200,2500].forEach(function(ms){ setTimeout(schedule,ms); });

      /* ses ac/kapa — sadece aktif kart */
      vp.addEventListener('click', function(e){
        var btn=e.target.closest('.hp-vid-snd'); if(!btn) return;
        e.preventDefault(); e.stopPropagation();
        var card=btn.closest('.hp-vid'), v=card.querySelector('video');
        if(!v || card!==active) return;
        if(v.muted){ v.muted=false; card.classList.add('sound');
          var pr=v.play(); if(pr&&pr.catch) pr.catch(function(){}); }
        else { v.muted=true; card.classList.remove('sound'); }
      });

      /* sepete ekle */
      vp.addEventListener('click', function(e){
        var b=e.target.closest('[data-vadd]'); if(!b) return;
        e.preventDefault(); e.stopPropagation();
        if(b.dataset.busy) return; b.dataset.busy='1';
        var orig=b.textContent; b.textContent='…';
        fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},
          body:JSON.stringify({items:[{id:parseInt(b.dataset.vadd,10),quantity:1}]})})
          .then(function(r){return r.json()})
          .then(function(){ b.textContent='Eklendi'; b.classList.add('done');
            document.dispatchEvent(new CustomEvent('hp:cart-added'));
            setTimeout(function(){ b.textContent=orig; b.classList.remove('done'); b.dataset.busy=''; },1600); })
          .catch(function(){ b.textContent='Hata';
            setTimeout(function(){b.textContent=orig;b.dataset.busy=''},1600); });
      });

      document.addEventListener('visibilitychange',function(){
        if(document.hidden){ if(active){ var v=active.querySelector('video'); if(v) v.pause(); } }
        else { schedule(); }
      });
    });
  }

  if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded',function(){init()}); }
  else { init(); }
  document.addEventListener('shopify:section:load',function(e){ init(e.target); });
})();
